import Swiper from 'swiper'
import SwiperComponent from './Swiper.vue'
import SlideComponent from './Slide.vue'
if (typeof window !== 'undefined') {
  window.Swiper = Swiper
}

export const swiper = SwiperComponent
export const swiperSlide = SlideComponent
export const swiperPlugins = Swiper.prototype.plugins

export default {
  install (Vue, options = {}) {
    Vue.component('swiper', SwiperComponent)
    Vue.component('swiper-slide', SlideComponent)
  }
}
